<div *ngIf="icon" class="media">
    <ng-content class="media-object" select="fui-icon"></ng-content>
</div>
<div class="label">
    <div class="label-title" id="label">
        {{title | translate}}
    </div>
</div>
